import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../../../core/pagination/datatable";
import { ROLL_CALL_API_BASE_URL } from "../RollCallConfig/RollCallConfig";
import { Spin } from "antd";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
// import RollcallApplyLeave from "../Leaves/ApplyLeave";
// import { CornerRightUp } from "feather-icons-react/build/IconComponents";
import PropTypes from "prop-types";
import dayjs from "dayjs";

const TabsComponent = ({ selectedDate }) => {
  const [status, setStatus] = useState("P");
  const [attendanceData, setAttendanceData] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [selectedRegId, setSelectedRegId] = useState(null);
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
    }
  }, []);

  useEffect(() => {
    if (tokenData && superIdData) {
      fetchAttendance(status);
    }
  }, [tokenData, superIdData, status, selectedDate]);

  // const getTodayDate = () => {
  //     const today = new Date();
  //     return today.toISOString().split("T")[0];
  // };

  const fetchAttendance = async (selectedStatus) => {
    if (superIdData && tokenData) {
      setLoading(true);
      // const fromDate = getTodayDate();
      // const toDate = getTodayDate();
      const formattedDate = dayjs(selectedDate).format("YYYY-MM-DD");

      const queryParams = new URLSearchParams({
        SuperId: superIdData,
        InStatus: selectedStatus,
        selectedDate: formattedDate,
      });
      try {
        if (status === "MS") {
          const today = new Date();
          const tomorrow = new Date();
          tomorrow.setDate(today.getDate() + 1);
          const formatDate = (date) => date.toISOString().split("T")[0];
          const startDate = formatDate(today);
          const endDate = formatDate(tomorrow);
          const response = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/reports/getReports?superid=${superIdData}&reportiid=107&StartDate=${startDate}&EndDate=${endDate}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
            },
          );
          const data = await response.json();
          if (data.status) {
            setAttendanceData(data.ResultData || []);
          } else {
            console.error("Fetch failed:", data.message);
          }
        } else {
          const response = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/Attendance/getAttendancebystatus?${queryParams.toString()}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
            },
          );
          const data = await response.json();
          if (data.status) {
            setAttendanceData(data.ResultData || []);
          } else {
            console.error("Fetch failed:", data.message);
          }
        }
      } catch (error) {
        console.error("Error:", error.message);
      } finally {
        setLoading(false);
      }
    }
  };

  const filteredData = attendanceData.filter((item) => {
    if (status === "MS") {
      return item.Employee && item.Employee.toLowerCase();
    } else {
      return (
        (item.UserName && item.UserName?.toLowerCase()) ||
        (item.Badge && item.Badge.toLowerCase())
      );
    }
  });

  const handleTabClick = (tabKey) => {
    const tabStatusMap = {
      present: "P",
      late: "L",
      absent: "A",
      leave: "LV",
      WeeklyOff: "WO",
      WeeklyOffOT: "WO",
      DailyManPower: "D",
      WrongShift: "H",
      mobileSwipes: "MS",
    };
    const newStatus = tabStatusMap[tabKey];
    setStatus(newStatus);
  };

  useEffect(() => {
    fetchAttendance(status);
  }, [status]);

  const presenties = [
    {
      title: "Badge Id",
      dataIndex: "Badge",
      sorter: (a, b) => a.Badge?.length - b.Badge?.length,
    },
    {
      title: "Employee",
      dataIndex: "UserName",
      sorter: (a, b) => a.UserName?.length - b.UserName?.length,
    },
    {
      title: "Department",
      dataIndex: "Department",
      sorter: (a, b) => a.Department?.length - b.Department?.length,
    },
    {
      title: "Reported Time",
      dataIndex: "FormatInTime",
      sorter: (a, b) => a.FormatInTime?.length - b.FormatInTime?.length,
    },
  ];

  const late = [
    {
      title: "Badge Id",
      dataIndex: "Badge",
      sorter: (a, b) => a.Badge?.length - b.Badge?.length,
    },
    {
      title: "Employee",
      dataIndex: "UserName",
      sorter: (a, b) => a.UserName?.length - b.UserName?.length,
    },
    {
      title: "Department",
      dataIndex: "Department",
      sorter: (a, b) => a.Department?.length - b.Department?.length,
    },
    {
      title: "Reported Time",
      dataIndex: "FormatInTime",
      sorter: (a, b) => a.FormatInTime?.length - b.FormatInTime?.length,
    },
    // { title: "Late By", dataIndex: "Time", sorter: (a, b) => a.Time?.length - b.Time?.length },
  ];

  const absent = [
    {
      title: "Badge Id",
      dataIndex: "Badge",
      sorter: (a, b) => a.Badge?.length - b.Badge?.length,
    },
    {
      title: "Employee",
      dataIndex: "UserName",
      sorter: (a, b) => a.UserName?.length - b.UserName?.length,
    },
    {
      title: "Department",
      dataIndex: "Department",
      sorter: (a, b) => a.Department.length - b.Department.length,
    },
    // {
    //   title: "Action",
    //   dataIndex: "action",
    //   render: (text, record) => (
    //     <>
    //       <Link
    //         className="action-set"
    //         to="#"
    //         data-bs-toggle="dropdown"
    //         aria-expanded="true"
    //       >
    //         <i className="fa fa-ellipsis-v" aria-hidden="true" />
    //       </Link>
    //       <ul className="dropdown-menu">
    //         <li>
    //           <Link
    //             to="#"
    //             className="dropdown-item"
    //             data-bs-toggle="offcanvas"
    //             data-bs-target="#offcanvasRightApplyLeave"
    //             aria-controls="offcanvasRightApplyLeave"
    //             onClick={(e) => {
    //               e.preventDefault();
    //               setSelectedRegId(record.RegId);
    //             }}
    //           >
    //             <CornerRightUp className="info-img text-primary"></CornerRightUp>
    //             Apply Leave
    //           </Link>
    //         </li>
    //       </ul>
    //     </>
    //   ),
    // },
  ];

  const leave = [
    {
      title: "Badge Id",
      dataIndex: "Badge",
      sorter: (a, b) => a.Badge?.length - b.Badge?.length,
    },
    {
      title: "Employee",
      dataIndex: "UserName",
      sorter: (a, b) => a.UserName?.length - b.UserName?.length,
    },
    {
      title: "Department",
      dataIndex: "Department",
      sorter: (a, b) => a.Department?.length - b.Department?.length,
    },
    {
      title: "Leave Type",
      dataIndex: "type",
      sorter: (a, b) => a.type?.length - b.type?.length,
    },
    {
      title: "Reason",
      dataIndex: "Reason",
      sorter: (a, b) => a.Reason?.length - b.Reason?.length,
    },
  ];

  //   const weeklyOff = [
  //     {
  //       title: "S.No",
  //       dataIndex: "sno",
  //       sorter: (a, b) => a.sno - b.sno,
  //       render: (_, __, index) => index + 1,
  //     },
  //     {
  //       title: "Badge Id",
  //       dataIndex: "Badge",
  //       sorter: (a, b) => a.Badge.length - b.Badge.length,
  //     },
  //     {
  //       title: "Employee",
  //       dataIndex: "UserName",
  //       sorter: (a, b) => a.UserName?.length - b.UserName?.length,
  //     },
  //     {
  //       title: "Designation",
  //       dataIndex: "Designation",
  //       sorter: (a, b) => a.Designation.length - b.Designation.length,
  //     },
  //     {
  //       title: "Department",
  //       dataIndex: "Department",
  //       sorter: (a, b) => a.Department.length - b.Department.length,
  //     },
  //   ];

  //   const weeklyOffOT = [
  //     {
  //       title: "S.No",
  //       dataIndex: "sno",
  //       sorter: (a, b) => a.sno - b.sno,
  //       render: (_, __, index) => index + 1,
  //     },
  //     {
  //       title: "Badge Id",
  //       dataIndex: "Badge",
  //       sorter: (a, b) => a.Badge.length - b.Badge.length,
  //     },
  //     {
  //       title: "Employee",
  //       dataIndex: "UserName",
  //       sorter: (a, b) => a.UserName?.length - b.UserName?.length,
  //       render: (text) =>
  //         text?.length > 15 ? `${text.substring(0, 15)}...` : text,
  //     },
  //     {
  //       title: "Designation",
  //       dataIndex: "Designation",
  //       sorter: (a, b) => a.Designation.length - b.Designation.length,
  //     },
  //     {
  //       title: "Department",
  //       dataIndex: "Department",
  //       sorter: (a, b) => a.Department.length - b.Department.length,
  //     },
  //   ];

  //   const DailyManPower = [
  //     {
  //       title: "S.No",
  //       dataIndex: "sno",
  //       sorter: (a, b) => a.sno - b.sno,
  //       render: (_, __, index) => index + 1,
  //     },
  //     {
  //       title: "Badge Id",
  //       dataIndex: "Badge",
  //       sorter: (a, b) => a.Badge.length - b.Badge.length,
  //     },
  //     {
  //       title: "Employee",
  //       dataIndex: "UserName",
  //       sorter: (a, b) => a.UserName?.length - b.UserName?.length,
  //       render: (text) =>
  //         text?.length > 15 ? `${text.substring(0, 15)}...` : text,
  //     },
  //     {
  //       title: "Designation",
  //       dataIndex: "Designation",
  //       sorter: (a, b) => a.Designation.length - b.Designation.length,
  //     },
  //     {
  //       title: "Department",
  //       dataIndex: "Department",
  //       sorter: (a, b) => a.Department.length - b.Department.length,
  //     },
  //   ];

  //   const WrongShift = [
  //     {
  //       title: "S.No",
  //       dataIndex: "sno",
  //       sorter: (a, b) => a.sno - b.sno,
  //       render: (_, __, index) => index + 1,
  //     },
  //     {
  //       title: "Badge Id",
  //       dataIndex: "IBadged",
  //       sorter: (a, b) => a.Badge.length - b.Badge.length,
  //     },
  //     {
  //       title: "Employee",
  //       dataIndex: "UserName",
  //       sorter: (a, b) => a.UserName?.length - b.UserName?.length,
  //       render: (text) =>
  //         text?.length > 15 ? `${text.substring(0, 15)}...` : text,
  //     },
  //     {
  //       title: "Designation",
  //       dataIndex: "Designation",
  //       sorter: (a, b) => a.Designation.length - b.Designation.length,
  //     },
  //     {
  //       title: "Department",
  //       dataIndex: "Department",
  //       sorter: (a, b) => a.Department.length - b.Department.length,
  //     },
  //   ];

  //   const OT = [
  //     {
  //       title: "S.No",
  //       dataIndex: "sno",
  //       sorter: (a, b) => a.sno - b.sno,
  //       render: (_, __, index) => index + 1,
  //     },
  //     {
  //       title: "Badge Id",
  //       dataIndex: "Badge",
  //       sorter: (a, b) => a.Id.length - b.Id.length,
  //     },
  //     {
  //       title: "Employee",
  //       dataIndex: "UserName",
  //       sorter: (a, b) => a.UserName?.length - b.UserName?.length,
  //       render: (text) =>
  //         text?.length > 15 ? `${text.substring(0, 15)}...` : text,
  //     },
  //     {
  //       title: "Designation",
  //       dataIndex: "Designation",
  //       sorter: (a, b) => a.Designation.length - b.Designation.length,
  //     },
  //     {
  //       title: "Department",
  //       dataIndex: "Department",
  //       sorter: (a, b) => a.Department.length - b.Department.length,
  //     },
  //   ];
  const mobileSwipes = [
    {
      title: "Biometric Id",
      dataIndex: "Biometric Id",
      sorter: (a, b) => a["Biometric Id"]?.length - b["Biometric Id"]?.length,
    },
    {
      title: "Employee",
      dataIndex: "Employee",
      sorter: (a, b) => a.Employee?.length - b.Employee?.length,
      render: (text) =>
        text?.length > 15 ? `${text.substring(0, 15)}...` : text,
    },
    {
      title: "Transaction Date",
      dataIndex: "Transaction Date",
      sorter: (a, b) =>
        new Date(a["Transaction Date"].split("/").reverse().join("-")) -
        new Date(b["Transaction Date"].split("/").reverse().join("-")),
    },
    {
      title: "Transaction Time",
      dataIndex: "Transaction Time",
      sorter: (a, b) =>
        a["Transaction Time"]?.localeCompare(b["Transaction Time"]),
    },
    {
      title: "Swipe Location",
      dataIndex: "Swipe Location",
      sorter: (a, b) =>
        a["Swipe Location"]?.length - b["Swipe Location"]?.length,
      render: (text) => (
        <span title={text}>
          {text?.length > 15 ? `${text.substring(0, 15)}...` : text}
        </span>
      ),
    },
    {
      title: "Map",
      dataIndex: "Map",
      render: (map) =>
        map ? <span dangerouslySetInnerHTML={{ __html: map }} /> : "-",
    },
  ];

  const tabItems = [
    { label: "Present", key: "present", columns: presenties, status: "P" },
    { label: "Late", key: "late", columns: late, status: "L" },
    { label: "Absent", key: "absent", columns: absent, status: "A" },
    { label: "Leave", key: "leave", columns: leave, status: "LV" },
    // { label: "Weekly Off", key: "WeeklyOff", columns: weeklyOff, status: "WO" },
    // {
    //     label: "WeeklyOffOT",
    //     key: "WeeklyOffOt",
    //     columns: weeklyOffOT,
    //     status: "WOO",
    // },
    // {
    //     label: "DailyManPower",
    //     key: "DailyManPower",
    //     columns: DailyManPower,
    //     status: "D",
    // },
    // {
    //     label: "WrongShift",
    //     key: "WrongShift",
    //     columns: WrongShift,
    //     status: "WS",
    // },
    // { label: "OT", key: "OT", columns: OT, status: "OT" },
    {
      label: "Mobile Swipes",
      key: "mobileSwipes",
      columns: mobileSwipes,
      status: "MS",
    },
  ];

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );

  const handleDownloadExcel = () => {
    if (filteredData && filteredData?.length === 0) {
      return;
    }

    const wb = XLSX.utils.book_new();
    let wsData = [];
    let sheetName = "";
    let fileName = "";

    if (status === "P" || status === "L") {
      wsData = filteredData?.map((item, index) => ({
        "S.No": index + 1,
        Badge: item.Badge,
        Employee: item.UserName,
        Department: item.Department,
        "Reported Time": item.FormatInTime,
      }));
      sheetName = status === "P" ? "Presenties" : "Late";
      fileName = sheetName + ".xlsx";
    }

    if (status === "A" || status === "WO") {
      wsData = filteredData?.map((item, index) => ({
        "S.No": index + 1,
        Badge: item.Badge,
        Employee: item.UserName,
        Department: item.Department,
      }));
      sheetName = status === "A" ? "Absentees" : "WeekOff";
      fileName = sheetName + ".xlsx";
    }

    if (status === "LV") {
      wsData = filteredData?.map((item, index) => ({
        "S.No": index + 1,
        Badge: item.Badge,
        Employee: item.UserName,
        Department: item.Department,
        Type: item.type,
        Reason: item.Reason,
      }));
      sheetName = "Leaves";
      fileName = "Leaves.xlsx";
    }

    if (status === "D" || status === "H" || status === "OT") {
      wsData = filteredData?.map((item, index) => ({
        "S.No": index + 1,
        Badge: item.Badge,
        Employee: item.UserName,
        Designation: item.Designation,
        Department: item.Department,
      }));
      if (status === "D") {
        sheetName = "DailyManPower";
        fileName = "DailyManPower.xlsx";
      } else if (status === "H") {
        sheetName = "WrongShift";
        fileName = "WrongShift.xlsx";
      } else if (status === "OT") {
        sheetName = "OT";
        fileName = "OT.xlsx";
      }
    }

    if (status === "MS") {
      wsData = filteredData?.map((item, index) => ({
        "S.No": index + 1,
        Employee: item.Employee,
        "Biometric Id": item["Biometric Id"],
        Date: item["Transaction Date"],
        Time: item["Transaction Time"],
        "Swipe Location": item["Swipe Location"],
      }));
      sheetName = "Mobile swipes";
      fileName = "Mobile swipes.xlsx";
    }

    const ws = XLSX.utils.json_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, sheetName);
    XLSX.writeFile(wb, fileName);
  };

  const generatePDF = () => {
    if (filteredData && filteredData?.length === 0) {
      return;
    }

    const doc = new jsPDF();
    if (status == "P") {
      doc.setProperties({
        title: "Presenties Report",
        author: "Admin",
        creator: "Rollcall",
      });

      const headers = [
        "S.no",
        "Badge",
        "Employee",
        "Department",
        "Reported Time",
      ];
      const tableData = filteredData?.map((item, index) => [
        index + 1,
        item.Badge,
        item.UserName,
        item.Department,
        item.FormatInTime,
      ]);

      doc.autoTable({ head: [headers], body: tableData });
      doc.save("Presenties.pdf");
    }
    if (status == "L") {
      doc.setProperties({
        title: "Late Report",
        author: "Admin",
        creator: "Rollcall",
      });

      const headers = [
        "S.no",
        "Badge",
        "Employee",
        "Department",
        "Reported Time",
      ];
      const tableData = filteredData?.map((item, index) => [
        index + 1,
        item.Badge,
        item.UserName,
        item.Department,
        item.FormatInTime,
      ]);

      doc.autoTable({ head: [headers], body: tableData });
      doc.save("Late.pdf");
    }
    if (status == "A") {
      doc.setProperties({
        title: "Absentees Report",
        author: "Admin",
        creator: "Rollcall",
      });

      const headers = ["S.no", "Badge", "Employee", "Department"];
      const tableData = filteredData?.map((item, index) => [
        index + 1,
        item.Badge,
        item.UserName,
        item.Department,
      ]);

      doc.autoTable({ head: [headers], body: tableData });
      doc.save("Absentees.pdf");
    }
    if (status == "LV") {
      doc.setProperties({
        title: "Leaves Report",
        author: "Admin",
        creator: "Rollcall",
      });

      const headers = [
        "S.no",
        "Badge",
        "Employee",
        "Department",
        "Type",
        "Reason",
      ];
      const tableData = filteredData?.map((item, index) => [
        index + 1,
        item.Badge,
        item.UserName,
        item.Department,
        item.type,
        item.Reason,
      ]);

      doc.autoTable({ head: [headers], body: tableData });
      doc.save("Leaves.pdf");
    }
    if (status == "WO") {
      doc.setProperties({
        title: "Week Off Report",
        author: "Admin",
        creator: "Rollcall",
      });

      const headers = ["S.no", "Badge", "Employee", "Department"];
      const tableData = filteredData?.map((item, index) => [
        index + 1,
        item.Badge,
        item.UserName,
        item.Department,
      ]);

      doc.autoTable({ head: [headers], body: tableData });
      doc.save("WeekOff.pdf");
    }
    if (status == "D") {
      doc.setProperties({
        title: "DailyManPower Report",
        author: "Admin",
        creator: "Rollcall",
      });

      const headers = [
        "S.no",
        "Badge",
        "Employee",
        "Department",
        "Designation",
      ];
      const tableData = filteredData?.map((item, index) => [
        index + 1,
        item.Badge,
        item.UserName,
        item.Designation,
        item.Department,
      ]);

      doc.autoTable({ head: [headers], body: tableData });
      doc.save("DailyManPower.pdf");
    }
    if (status == "H") {
      doc.setProperties({
        title: "WrongShift Report",
        author: "Admin",
        creator: "Rollcall",
      });

      const headers = [
        "S.no",
        "Badge",
        "Employee",
        "Department",
        "Designation",
      ];
      const tableData = filteredData?.map((item, index) => [
        index + 1,
        item.Badge,
        item.UserName,
        item.Designation,
        item.Department,
      ]);

      doc.autoTable({ head: [headers], body: tableData });
      doc.save("WrongShift.pdf");
    }
    if (status == "OT") {
      doc.setProperties({
        title: "OT Report",
        author: "Admin",
        creator: "Rollcall",
      });

      const headers = [
        "S.no",
        "Badge",
        "Employee",
        "Department",
        "Designation",
      ];
      const tableData = filteredData?.map((item, index) => [
        index + 1,
        item.Badge,
        item.UserName,
        item.Designation,
        item.Department,
      ]);

      doc.autoTable({ head: [headers], body: tableData });
      doc.save("OT.pdf");
    }
    if (status == "MS") {
      doc.setProperties({
        title: "Mobile Swipes Report",
        author: "Admin",
        creator: "Rollcall",
      });

      const headers = [
        "S.no",
        "Employee",
        "Biometric Id",
        "Date",
        "Time",
        "Swipe Location",
      ];
      const tableData = filteredData?.map((item, index) => [
        index + 1,
        item.Employee,
        item["Biometric Id"],
        item["Transaction Date"],
        item["Transaction Time"],
        item["Swipe Location"],
      ]);

      doc.autoTable({ head: [headers], body: tableData });
      doc.save("Mobile Swipes.pdf");
    }
  };

  return (
    <div className="row">
      <div className="col-12">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-between">
              <ul className="nav nav-tabs nav-tabs-bottom mb-3">
                {tabItems?.map((tab) => (
                  <li className="nav-item" key={tab.key}>
                    <Link
                      className={`nav-link ${
                        status === tab.status ? "active" : ""
                      }`}
                      to={`#${tab.key}`}
                      data-bs-toggle="tab"
                      onClick={() => handleTabClick(tab.key)}
                    >
                      {tab.label}
                    </Link>
                  </li>
                ))}
              </ul>
              <div className="d-flex align-items-center ">
                <div className="me-2">
                  <OverlayTrigger placement="top" overlay={renderTooltip}>
                    <Link onClick={generatePDF}>
                      <ImageWithBasePath
                        src="assets/img/icons/pdf.svg"
                        alt="img"
                      />
                    </Link>
                  </OverlayTrigger>
                </div>
                <div>
                  <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                    <Link
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      onClick={handleDownloadExcel}
                    >
                      <ImageWithBasePath
                        src="assets/img/icons/excel.svg"
                        alt="img"
                      />
                    </Link>
                  </OverlayTrigger>
                </div>
              </div>
            </div>
            <div className="tab-content">
              {tabItems?.map((tab) => (
                <div
                  className={`tab-pane ${
                    status === tab.status ? "show active" : ""
                  }`}
                  id={tab.key}
                  key={tab.key}
                >
                  <div className="table-list-card">
                    <div className="table-responsive">
                      {loading ? (
                        <div className="text-center my-4">
                          <Spin size="large" />
                          <p>Loading data...</p>
                        </div>
                      ) : filteredData.length > 0 ? (
                        <Table
                          columns={tab.columns}
                          dataSource={filteredData}
                          rowKey="id"
                          pagination={false}
                          pgno={true}
                        />
                      ) : (
                        <p className="text-center my-4">No data available</p>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* <RollcallApplyLeave selectedRegId={selectedRegId} /> */}
    </div>
  );
};

TabsComponent.propTypes = {
  selectedDate: PropTypes.node.isRequired,
};

export default TabsComponent;
